import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie9';
import 'url-search-params-polyfill';

// fix for react-color not working properly in IE
if (!window.document.contains) {
  window.document.contains = window.document?.body.contains.bind(window.document.body);
}
